<template>
  <pages-wrapper>
    <div class="club-page">
      <h1 class="club-title">
        {{ pageTitle }}
      </h1>

      <banners-slot
        class="club-welcome-banner"
        :with-category="false"
        slot-name="banner_info_club1"
      />

      <fragment
        class="club-advantages"
        prefetch
        slot-name="club_info_advantages"
      />

      <banners-slot
        class="club-middle-banner"
        :with-category="false"
        slot-name="banner_info_club2"
      />

      <fragment
        prefetch
        slot-name="club_info_guide"
      />

      <banners-slot
        class="club-footer-banner"
        :with-category="false"
        slot-name="banner_info_club3"
      />

      <h2>Вопросы и ответы</h2>

      <ui-accordion
        class="club-questions"
        :items="clubQuestions"
      />
    </div>
  </pages-wrapper>
</template>

<script>
import PagesWrapper from '../../components/info-pages/pages-wrapper';
import BannersSlot from '../../components/banners-slot/banners-slot';
import UiAccordion from '../../components/kit/ui-accordion/ui-accordion';
import Fragment from '../../components/info-pages/fragment';
import pageMetaMixin from '@/mixins/page-meta-mixin';

export default {
  name: 'club',

  metaInfo() {
    return this.getPageMeta({ pageTitle: this.pageTitle });
  },

  components: {
    Fragment,
    UiAccordion,
    BannersSlot,
    PagesWrapper
  },

  mixins: [pageMetaMixin],

  data() {
    return {
      pageTitle: 'Клубная программа',
      clubQuestions: [
        {
          title: 'Что такое Клубная программа FUNDAY?',
          description: 'Это программа поощрений для покупателей FUNDAY. Участнику программы при выполнении различных условий (совершение покупок, заполнение актуальных анкетных данных и т.д.) предоставляются выгодные предложения, скидки.'
        },
        {
          title: 'Как стать участником Клубной программы FUNDAY?',
          description: 'При совершении покупки в розничном магазине FUNDAY заполните анкету участника и получите Клубную карту или пройдите регистрацию в Клубной программе на сайте <a href="www.fundayshop.com">www.fundayshop.com</a>, заполнив все обязательные поля в регистрационной форме.'
        },
        {
          title: 'Как будет использована информация, указанная мной в анкете при регистрации в Клубной программе?',
          description: 'Информация будет использована для: <ul><li>формирования и отправки наиболее интересных вам предложений</li><li>совершения покупок без Клубной карты – через SMS-авторизацию по номеру телефона, указанного в контактных данных</li><li>восстановления Клубной карты в случае её утраты</li></ul>'
        },
        {
          title: 'Могу ли я передавать свою Клубную карту друзьям или родственникам?',
          description: 'Клубная карта не является именной и действует на предъявителя. Вы можете передавать свою карту друзьям или родственникам для накопления и/или траты бонусов. Но переоформить Клубную карту на другое имя или узнать бонусный баланс может только владелец (указан при заполнении анкеты участника Клубной программы) Клубной карты.'
        },
        {
          title: 'Как поменять мою контактную информацию?',
          description: 'Войдите в личный кабинет на сайте, здесь вы можете изменить или дополнить вашу контактную информацию (Email и номер телефона). Для сохранения изменений нажмите кнопку «Сохранить». Обновлённые данные поступят в базу данных в режиме реального времени. <br><br>Вы также можете заполнить анкету в магазине с новыми данными. Информация поступит в систему после обработки анкеты в срок до 3-х месяцев.'
        },
        {
          title: 'Что такое бонусы?',
          description: 'За выполнение различных условий – совершение покупок, заполнение анкетных данных, участие в акциях – вам могут быть зачислены подарочные бонусы. 1 бонус равен 1 рублю.'
        },
        {
          title: 'Какой курс оплаты товара бонусами?',
          description: '1 бонус = 1 рублю.'
        },
        {
          title: 'Как накапливаются бонусы?',
          description: 'За покупки начисляется 25 бонусов за каждые полные 500 рублей в чеке при условии, что на товар не установлена скидка. На часть покупки, оплаченную бонусами, бонусы не начисляются. На покупки до 500 рублей бонусы не начисляются.'
        },
        {
          title: 'В каких магазинах я могу использовать бонусы?',
          description: 'Списание бонусов возможно во всех магазинах FUNDAY на территории Российской Федерации, а также в интернет-магазине <a href="www.fundayshop.com">www.fundayshop.com</a>'
        },
        {
          title: 'На какие покупки я могу потратить бонусы?',
          description: 'Бонусами можно оплатить любой товар, в том числе товар со скидкой.'
        },
        {
          title: 'Какую сумму покупки я могу оплатить бонусами?',
          description: 'Бонусами можно оплатить до 30% от итоговой стоимости товара. Бонусы не могут быть использованы на оплату доставки при заказе в интернет-магазине.'
        },
        {
          title: 'Сколько времени действительны накопленные бонусы?',
          description: 'Бонусы имеют срок действия. Неиспользованные бонусы аннулируются 11 марта ежегодно. Бонусы, начисленные с 1 января по 10 марта текущего года, не аннулируются, а действуют до 11 марта следующего года. Накопленная сумма покупок по Клубной карте сохраняется. Бонусы, полученные в рамках специальных акций, аннулируются по правилам данных акций.'
        },
        {
          title: 'Когда бонусы появятся на моем счёте?',
          description: 'Бонусы появятся на счёте через сутки после покупки в магазине FUNDAY. И в течение 10 рабочих дней после оплаты заказа при покупке в интернет-магазине <a href="www.fundayshop.com">www.fundayshop.com</a>.'
        },
        {
          title: 'Если я возвращаю товар, что произойдёт с моими бонусами?',
          description: 'При возврате товара бонусы, начисленные за эту покупку, будут аннулированы. Если бонусы за возвращаемый товар уже использованы, то бонусный счёт может стать отрицательным. В этом случае воспользоваться бонусной скидкой можно только после пополнения бонусного счёта на карте. <br>Бонусы, полученные в рамках специальных акций, возвращаются согласно правилам данных акций.'
        },
        {
          title: 'Что делать, если совершённая мной покупка не учтена на бонусном балансе или за неё не зачислены бонусы?',
          description: `Если по какой-либо причине совершённая вами покупка не учтена на бонусном балансе или за неё не зачислены бонусы, обратитесь по телефону горячей линии 8 800 770-01-01 или по электронной почте <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>, указав при этом:
          <ul><li>номер мобильного телефона, который вы указывали при регистрации в Клубной программе</li>
          <li>номер Клубной карты</li>
          <li>номера чека (номер ПР-… - он указан на чеке), а также адрес магазина, в котором была совершена данная покупка.</li></ul>`
        },
        {
          title: 'Если я потерял Клубную карту, могу ли я её восстановить?',
          description: 'Да, утерянную карту можно восстановить. Для этого нужно обратиться к администратору любого магазина-участника Клубной программы FUNDAY. Все накопленные бонусы и общая сумма покупок перейдёт на новую Клубную карту.Об утере Клубной карты необходимо как можно скорее сообщить по телефону 8 800 770-01-01 или на <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>, так как накопленные бонусы могут потратить до того, как вам выдадут новую карту. Восстановить бонусы в этом случае будет невозможно.'
        },
        {
          title: 'Как и где я могу проверить состояние своего бонусного счёта?',
          description: 'Бонусный баланс можно проверить в личном кабинете на сайте <a href="www.fundayshop.com">www.fundayshop.com</a>, обратившись по телефону горячей линии 8 800 770-01-01, либо по электронной почте <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>'
        },
        {
          title: 'Как и где узнать о специальных предложениях?',
          description: 'В магазинах FUNDAY, на сайте <a href="www.fundayshop.com">www.fundayshop.com</a>, на страницах FUNDAY в социальных сетях, по телефону 8 800 770-01-01, через SMS и Email-рассылки. Подпишитесь на новости любым удобным для вас способом (SMS или Email), чтобы не пропустить выгодные предложения FUNDAY.'
        },
        {
          title: 'Как отказаться от получения сообщений на телефон/ Email?',
          description: `Выберите один из удобных способов: <ul><li><span>Оставьте заявку по телефону 8 800 770-01-01 или на <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>. Запрос будет обработан в течение 5 рабочих дней</span></li><li><span>Зарегистрируйте вашу Клубную карту в личном кабинете на сайте <a href="www.fundayshop.com">www.fundayshop.com</a> и во вкладке «Подписки» измените их статусы.</span></li></ul>`
        },
        {
          title: 'Могу ли я получить или потратить бонусы, если забыл Клубную карту?',
          description: 'Вам не нужно беспокоиться, что вы забыли пластиковую карту. <br>Для того, чтобы учесть вашу покупку в Клубной программе, достаточно назвать кассиру номер телефона, указанный при регистрации. <br>В случае списания бонусов при покупке необходимо сообщить кассиру код, который вы получите в SMS.'
        },
        {
          title: 'Могу ли я использовать бонусы на оплату Подарочной карты?',
          description: 'Нет. Бонусами нельзя оплатить покупку Подарочной карты. За товар, оплаченный Подарочной картой, бонусы начисляются на сумму, превышающую номинал карты.'
        },
        {
          title: 'Что делать, если я не нашёл ответ на свой вопрос?',
          description: 'Если у вас остались вопросы, на которые вы не нашли ответ в этом разделе, обратитесь на горячую линию 8 800 770-01-01 или по электронной почте <a href="mailto:fc@fundayshop.com">fc@fundayshop.com</a>.'
        }
      ],
    };
  },
};
</script>

<style lang="scss">
.club-page {
  h2 {
    margin-bottom: 12px;
  }

  .club-welcome-banner,
  .club-footer-banner {
    .banner {
      height: auto;
    }
  }
}

@include breakpoint("desktop") {
  .club-page {
    h2 {
      margin-bottom: 16px;
    }
  }
}
</style>
